import { handleDecimals, localizeNumber } from './numberFormatters';
import * as easings from './easings';

export function counter(el) {
    // hardcoded constants for now
    const frameDuration = 1000 / 60; // this is 60fps

    // customizable config from elements dataset with fallbacks to default values
    const duration = el.dataset?.ctCounterDuration ?? 2000;
    const startValue = el.dataset?.ctCounterStartValue ?? 0;
    let endValue = el.dataset?.ctCounterEndValue;
    const decimals = el.dataset?.ctCounterDecimals ?? 0;
    const easing = el.dataset?.ctCounterEasing ?? 'easeOutQuad';
    const easingFunction = easings[easing] || easings.easeOutQuad;
    const localize = el.dataset?.ctCounterLocalize ?? false;

    if (startValue > 0 && !endValue) {
        endValue = 0;
    }

    // nothing to do
    if (!endValue && endValue !== 0) {
        return;
    }

    const argsToCheck = [startValue, endValue, decimals, duration];

    // sanity checks
    const errorMsg = [];
    argsToCheck.forEach((arg) => {
        if (isNaN(arg)) {
            errorMsg.push(
                `CT Counter error: please make sure start value in data-ct-counter-start-value is set to a number. It currently is ${arg}. Aborting counter initialization.`
            );
        }
    });

    if (errorMsg.length > 0) {
        errorMsg.forEach((msg) => console.error(msg));
        return;
    }

    // config based on given values
    const totalFrames = Math.round(duration / frameDuration);

    let frame = 0;
    const countFrom = handleDecimals(startValue, decimals);
    const countTo = handleDecimals(endValue, decimals);
    const isCountingUp = countFrom < countTo;

    // actual animation
    const counter = setInterval(() => {
        frame++;
        const progress = easingFunction(frame / totalFrames);
        const currentCount = isCountingUp
            ? Math.round(countTo * progress)
            : Math.round(countFrom - countFrom * progress);

        if (parseInt(el.dataset?.ctCounterLastValue) !== currentCount) {
            const countWithDecimals = handleDecimals(currentCount, decimals, 'return');

            el.dataset.ctCounterLastValue = currentCount;
            el.textContent = localize ? localizeNumber(countWithDecimals, localize) : countWithDecimals;
        }

        if (frame === totalFrames) {
            clearInterval(counter);
        }
    }, frameDuration);
}
